export const BRAND_TV_DOMAIN = import.meta.env.VITE_BRAND_TV_DOMAIN;

export default function isCurrentlyOnBrandTVDomain() {
	return !!BRAND_TV_DOMAIN && window.location.hostname.endsWith(BRAND_TV_DOMAIN);
}
